module.exports = __webpack_public_path__ + "static/media/mens-watches.80ca6741.png";